import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-consulta-leilao',
  templateUrl: './consulta-leilao.component.html',
  styleUrls: ['./consulta-leilao.component.scss']
})
export class ConsultaLeilaoComponent implements OnInit {

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';
  nivel = 0;



  listaFotos:any[] = [];

  @Input() token = '';

  constructor() { }

  ngOnInit() { }


  ngOnChanges() {

    this.setNivel();
    this.status = ((this.codigoControle != "SEMREGISTRO_OK") && ((this.consulta && this.consulta.lista && this.consulta.lista.length) > 0)) ? 'danger' : 'success';
  }

  setNivel(){
    if(this.consulta != null && this.consulta.lista!=null && this.consulta.lista.length > 0){
      for(let i=0; i<this.consulta.lista.length; i++){
        if(this.consulta.lista[i].nomeFoto1 == "01.jpg"){
          this.nivel = 1;
        }
        if(this.consulta.lista[i].nomeFoto2 == "01.jpg"){
          this.nivel = 1;
        }
        if(this.consulta.lista[i].nomeFoto3 == "01.jpg"){
          this.nivel = 1;
        }
        if(this.consulta.lista[i].nomeFoto4 == "01.jpg"){
          this.nivel = 1;
        }
        if(this.consulta.lista[i].nomeFoto1 == "02.jpg" && this.nivel < 5){
          this.nivel = 5;
        }
        if(this.consulta.lista[i].nomeFoto2 == "02.jpg" && this.nivel < 5){
          this.nivel = 5;
        }
        if(this.consulta.lista[i].nomeFoto3 == "02.jpg" && this.nivel < 5){
          this.nivel = 5;
        }
        if(this.consulta.lista[i].nomeFoto4 == "02.jpg" && this.nivel < 5){
          this.nivel = 5;
        }
        if(this.consulta.lista[i].nomeFoto1 == "03.jpg" && this.nivel < 10){
          this.nivel = 10;
        }
        if(this.consulta.lista[i].nomeFoto2 == "03.jpg" && this.nivel < 10){
          this.nivel = 10;
        }
        if(this.consulta.lista[i].nomeFoto3 == "03.jpg" && this.nivel < 10){
          this.nivel = 10;
        }
        if(this.consulta.lista[i].nomeFoto4 == "03.jpg" && this.nivel < 10){
          this.nivel = 10;
        }
      }
    }
  }

}
